import React from "react";
import type { GraphNode } from "../../pages/internal-debugger/InternalDebuggerPage";
import "./InternalDebuggerStateValueView.scss";

export interface DebuggerStateValueViewProps {
  state: GraphNode;
}

const DebuggerStateValueView = (props: DebuggerStateValueViewProps) => {
  const { state } = props;
  let value = state.value.derived;
  if (typeof value === "undefined") {
    value = state.value.input;
  }
  const display = typeof value === "undefined" ? state.value.error : value;
  const isResolved = typeof value !== "undefined";

  return (
    <div>
      <pre className={`RuleNode__value ${isResolved ? "--resolved" : ""} ${display === null ? "--uncertain" : ""}`}>
        {value && typeof value === "object" && "temporal" in value
          ? value.temporal.ranges
              .sort((a, b) => new Date(a.r.start).valueOf() - new Date(b.r.start).valueOf())
              .map((range) => {
                const { r, v } = range;
                const start = new Date(r.start);
                return (
                  <div key={r.start}>
                    {r.start} ({start.valueOf()}) = {JSON.stringify(v, null, 2)}
                  </div>
                );
              })
          : display === undefined
            ? "Unknown"
            : display === null
              ? "Uncertain"
              : JSON.stringify(display, null, 2)}
      </pre>
    </div>
  );
};

export default DebuggerStateValueView;
